import { useMemo } from 'react';
import { pick } from 'es-toolkit';
import { getDisplayedCount, getObjectTypeFilterButtonLabel } from '@pkgs/components/utils/objectTypeFilterButtonUtils';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { BusinessArea } from '@ev-tech/search-modules-api';

import { ObjectTypeFilterDropdown } from './ObjectTypeFilterDropdown';
import { ObjectTypeFilter } from './ObjectTypeFilter';
import { defaultObjectTypeFilterState } from '../../hooks/stores/search/slices/objectTypeFilterSlice';

export const ObjectTypeFilterButton = () => {
  const { t } = useAppContext();

  const isActive = useSearchStore(
    (state) => state.objectTypeCategory !== BusinessArea.residential || getDisplayedCount(state.propertyTypeState) > 0,
  );
  const propertyTypeState = useSearchStore((state) => state.propertyTypeState);
  const objectTypeCategory = useSearchStore((state) => state.objectTypeCategory);
  const displayedFilterCount = getDisplayedCount(propertyTypeState);

  const buttonLabel = useMemo(
    () =>
      getObjectTypeFilterButtonLabel({
        propertyTypeState,
        objectTypeCategory,
        displayedFilterCount,
        t,
      }),
    [objectTypeCategory, displayedFilterCount, propertyTypeState, t],
  );

  return (
    <ObjectTypeFilterDropdown
      label={buttonLabel}
      count={displayedFilterCount > 1 ? displayedFilterCount - 1 : undefined}
      isActive={isActive}
      defaultState={pick(defaultObjectTypeFilterState, ['objectTypeCategory', 'propertyTypeState'])}
      data-testid="search-components_object-type-filter-button"
    >
      <ObjectTypeFilter />
    </ObjectTypeFilterDropdown>
  );
};
